export const stpDummyData = {
  site: {
    name: "Green Valley STP",
    location: "Pune, Maharashtra",
    capacity: 5000,         // m³/day
    currentLoad: 3840,
    technology: "MBBR + Activated Sludge",
    operator: "Pune Municipal Corporation",
    commissionedDate: "2022-04-01",
  },

  summary: {
    healthScore: 82,
    inletFlow: 3840,          // m³/day
    treatedOutput: 3612,      // m³/day
    reusePercentage: 74,      // %
    blowersRunning: 3,
    blowersTotal: 4,
    activeAlarms: 4,
    complianceStatus: "Compliant",
    aiInsights: [
      "DO level has been below optimal (2.0 mg/L) for 3 hours — increase blower RPM.",
      "Inlet TSS spike detected at 07:30 — check incoming sewage quality.",
      "Recirculation pump P-04 due for maintenance in 2 days.",
      "Outlet BOD at 8 mg/L — 40% margin to CPCB limit, compliance safe.",
      "Energy optimization: Blower 3 can reduce RPM by 10% without DO impact.",
    ],
  },

  processStages: [
    { id: "S1", name: "Screen Chamber",       seq: 1, level: 68, flowIn: 160, flowOut: 158, status: "NORMAL",  pumpStatus: "Running",  blowerStatus: null,     ph: 7.2, tss: 420, do: null,  mlss: null, turbidity: null, chlorine: null },
    { id: "S2", name: "Equalization Tank",    seq: 2, level: 72, flowIn: 158, flowOut: 155, status: "NORMAL",  pumpStatus: "Running",  blowerStatus: null,     ph: 7.1, tss: 380, do: null,  mlss: null, turbidity: null, chlorine: null },
    { id: "S3", name: "Aeration Tank",        seq: 3, level: 65, flowIn: 155, flowOut: 152, status: "WARNING", pumpStatus: "Running",  blowerStatus: "Running", ph: 7.4, tss: null, do: 1.8,  mlss: 3200, turbidity: null, chlorine: null, blowerRpm: 1450, oxygenEff: 22.4 },
    { id: "S4", name: "Secondary Clarifier",  seq: 4, level: 78, flowIn: 152, flowOut: 148, status: "NORMAL",  pumpStatus: "Running",  blowerStatus: null,     ph: 7.3, tss: 48,  do: null,  mlss: null, turbidity: null, chlorine: null },
    { id: "S5", name: "Sand Filter",          seq: 5, level: 85, flowIn: 148, flowOut: 144, status: "NORMAL",  pumpStatus: "Running",  blowerStatus: null,     ph: 7.2, tss: 18,  do: null,  mlss: null, turbidity: 4.2,  chlorine: null },
    { id: "S6", name: "Chlorination Tank",    seq: 6, level: 60, flowIn: 144, flowOut: 142, status: "NORMAL",  pumpStatus: "Running",  blowerStatus: null,     ph: 7.1, tss: null, do: null,  mlss: null, turbidity: null, chlorine: 0.8  },
    { id: "S7", name: "Treated Water Tank",   seq: 7, level: 55, flowIn: 142, flowOut: 138, status: "NORMAL",  pumpStatus: "Running",  blowerStatus: null,     ph: 7.2, tss: 12,  do: null,  mlss: null, turbidity: 3.1,  chlorine: 0.7  },
    { id: "S8", name: "Sludge Holding Tank",  seq: 8, level: 45, flowIn: null, flowOut: null, status: "NORMAL", pumpStatus: "Standby", blowerStatus: null,     ph: null, tss: null, do: null, mlss: null, turbidity: null, chlorine: null },
  ],

  inlet: {
    flowRate: 160,        // m³/hr
    dailyVolume: 3840,    // m³/day
    ph: 7.8,
    tss: 420,             // mg/L
    cod: 380,             // mg/L
    bod: 210,             // mg/L
    peakHours: ["07:00–09:00", "12:00–14:00", "19:00–21:00"],
    hourlyTrend: [
      { t: "00:00", flow: 62, ph: 7.4 }, { t: "01:00", flow: 48, ph: 7.3 },
      { t: "02:00", flow: 42, ph: 7.2 }, { t: "03:00", flow: 38, ph: 7.2 },
      { t: "04:00", flow: 44, ph: 7.3 }, { t: "05:00", flow: 58, ph: 7.4 },
      { t: "06:00", flow: 98, ph: 7.6 }, { t: "07:00", flow: 182, ph: 7.9 },
      { t: "08:00", flow: 210, ph: 8.1 }, { t: "09:00", flow: 194, ph: 7.8 },
      { t: "10:00", flow: 168, ph: 7.7 }, { t: "11:00", flow: 172, ph: 7.6 },
      { t: "12:00", flow: 190, ph: 7.8 }, { t: "13:00", flow: 184, ph: 7.7 },
      { t: "14:00", flow: 162, ph: 7.6 }, { t: "15:00", flow: 148, ph: 7.5 },
      { t: "16:00", flow: 155, ph: 7.5 }, { t: "17:00", flow: 164, ph: 7.6 },
      { t: "18:00", flow: 178, ph: 7.7 }, { t: "19:00", flow: 196, ph: 7.9 },
      { t: "20:00", flow: 188, ph: 7.8 }, { t: "21:00", flow: 162, ph: 7.6 },
      { t: "22:00", flow: 118, ph: 7.5 }, { t: "23:00", flow: 82, ph: 7.4 },
    ],
    weeklyTrend: [
      { day: "Mon", volume: 3620 }, { day: "Tue", volume: 3780 },
      { day: "Wed", volume: 3840 }, { day: "Thu", volume: 3950 },
      { day: "Fri", volume: 4020 }, { day: "Sat", volume: 3200 },
      { day: "Sun", volume: 2880 },
    ],
  },

  aeration: {
    doLevel: 1.8,         // mg/L (optimal: 2–4)
    doTarget: 2.5,
    mlss: 3200,           // mg/L (optimal: 2500–4000)
    tankLevel: 65,
    oxygenTransferEff: 22.4,
    sludgeConcentration: 8.4,    // g/L
    blowers: [
      { id: "BL-01", name: "Blower 1", status: "Running",  rpm: 1450, power: 18.5, airFlow: 420, runHours: 4.2, efficiency: 88 },
      { id: "BL-02", name: "Blower 2", status: "Running",  rpm: 1420, power: 18.2, airFlow: 410, runHours: 6.1, efficiency: 86 },
      { id: "BL-03", name: "Blower 3", status: "Running",  rpm: 1380, power: 17.8, airFlow: 395, runHours: 2.8, efficiency: 84 },
      { id: "BL-04", name: "Blower 4", status: "Standby",  rpm: 0,    power: 0,    airFlow: 0,   runHours: 0,   efficiency: null },
    ],
    doHistory: [
      { t: "06:00", do: 2.8 }, { t: "07:00", do: 2.6 }, { t: "08:00", do: 2.2 },
      { t: "09:00", do: 1.9 }, { t: "10:00", do: 1.8 }, { t: "11:00", do: 1.8 },
      { t: "12:00", do: 2.0 }, { t: "13:00", do: 2.1 }, { t: "14:00", do: 2.3 },
      { t: "15:00", do: 2.4 }, { t: "16:00", do: 2.2 }, { t: "17:00", do: 2.0 },
    ],
  },

  pumps: [
    { id: "P-01", name: "Inlet Transfer Pump 1", type: "Transfer",     status: "Running",  runHours: 6.4, current: 18.2, power: 4.2, vibration: 1.2, efficiency: 88, nextMaintenance: "15 Mar 2026", failureRisk: 12 },
    { id: "P-02", name: "Inlet Transfer Pump 2", type: "Transfer",     status: "Standby",  runHours: 0,   current: 0,    power: 0,   vibration: null, efficiency: null, nextMaintenance: "22 Mar 2026", failureRisk: 8 },
    { id: "P-03", name: "Sludge Pump 1",         type: "Sludge",       status: "Running",  runHours: 3.2, current: 12.4, power: 3.1, vibration: 1.8, efficiency: 82, nextMaintenance: "10 Mar 2026", failureRisk: 28 },
    { id: "P-04", name: "Recirculation Pump",    type: "Recirculation",status: "Running",  runHours: 8.2, current: 22.6, power: 5.4, vibration: 0.9, efficiency: 91, nextMaintenance: "28 Feb 2026", failureRisk: 42 },
    { id: "P-05", name: "Backwash Pump",         type: "Backwash",     status: "Idle",     runHours: 0.4, current: 0,    power: 0,   vibration: null, efficiency: null, nextMaintenance: "1 Apr 2026",  failureRisk: 6  },
    { id: "P-06", name: "Treated Water Pump",    type: "Transfer",     status: "Running",  runHours: 5.8, current: 16.8, power: 3.8, vibration: 1.1, efficiency: 86, nextMaintenance: "20 Mar 2026", failureRisk: 15 },
  ],

  outlet: {
    flowRate: 138,         // m³/hr
    ph: 7.2,               // limit: 6.5–8.5
    tds: 680,              // mg/L limit: 2100
    turbidity: 3.1,        // NTU limit: 10
    residualChlorine: 0.8, // mg/L
    bod: 8,                // mg/L limit: 20
    cod: 42,               // mg/L limit: 100
    tss: 12,               // mg/L limit: 30
    compliance: "Compliant",
    limits: {
      ph:          { min: 6.5, max: 8.5, unit: "" },
      tds:         { max: 2100, unit: "mg/L" },
      turbidity:   { max: 10,   unit: "NTU"  },
      bod:         { max: 20,   unit: "mg/L" },
      cod:         { max: 100,  unit: "mg/L" },
      tss:         { max: 30,   unit: "mg/L" },
    },
    hourlyPh: [
      { t: "06:00", ph: 7.4 }, { t: "07:00", ph: 7.3 }, { t: "08:00", ph: 7.2 },
      { t: "09:00", ph: 7.1 }, { t: "10:00", ph: 7.2 }, { t: "11:00", ph: 7.3 },
      { t: "12:00", ph: 7.4 }, { t: "13:00", ph: 7.3 }, { t: "14:00", ph: 7.2 },
      { t: "15:00", ph: 7.1 }, { t: "16:00", ph: 7.2 }, { t: "17:00", ph: 7.3 },
    ],
  },

  sludge: {
    tankLevel: 45,              // %
    dewateringStatus: "Running",
    lastRemoval: "27 Feb 2026 08:00",
    dryingCycleActive: false,
    dryingBedLevel: 30,         // % full
    removalLog: [
      { date: "27 Feb 2026", volume: 4.2, destination: "Composting Facility", operator: "Raj Kumar",   truckId: "MH-12-AB-4521" },
      { date: "24 Feb 2026", volume: 3.8, destination: "Composting Facility", operator: "Anil Sharma", truckId: "MH-12-CD-7832" },
      { date: "21 Feb 2026", volume: 4.6, destination: "Landfill",            operator: "Raj Kumar",   truckId: "MH-12-EF-2291" },
      { date: "18 Feb 2026", volume: 3.5, destination: "Composting Facility", operator: "Suresh Yadav",truckId: "MH-12-AB-4521" },
      { date: "15 Feb 2026", volume: 4.1, destination: "Composting Facility", operator: "Anil Sharma", truckId: "MH-12-GH-5510" },
    ],
  },

  compliance: {
    status: "Compliant",
    lastAuditDate: "20 Feb 2026",
    nextAuditDate: "20 Mar 2026",
    violations: 0,
    authorityName: "MPCB (Maharashtra PCB)",
    permitNumber: "MPCB-STP-2022-0481",
    dailyLog: [
      { date: "28 Feb 2026", ph: 7.2, bod: 8,  cod: 42,  tss: 12, turbidity: 3.1, chlorine: 0.8, compliant: true  },
      { date: "27 Feb 2026", ph: 7.3, bod: 9,  cod: 45,  tss: 14, turbidity: 3.4, chlorine: 0.7, compliant: true  },
      { date: "26 Feb 2026", ph: 7.1, bod: 7,  cod: 38,  tss: 11, turbidity: 2.8, chlorine: 0.9, compliant: true  },
      { date: "25 Feb 2026", ph: 7.4, bod: 11, cod: 52,  tss: 16, turbidity: 4.1, chlorine: 0.6, compliant: true  },
      { date: "24 Feb 2026", ph: 7.6, bod: 14, cod: 68,  tss: 22, turbidity: 5.8, chlorine: 0.5, compliant: true  },
      { date: "23 Feb 2026", ph: 8.4, bod: 18, cod: 88,  tss: 27, turbidity: 8.2, chlorine: 0.4, compliant: true  },
      { date: "22 Feb 2026", ph: 8.6, bod: 24, cod: 112, tss: 34, turbidity: 12.4,chlorine: 0.2, compliant: false },
    ],
    violationHistory: [
      { date: "22 Feb 2026", parameter: "COD", value: "112 mg/L", limit: "100 mg/L", action: "Aeration extended 2h" },
      { date: "10 Jan 2026", parameter: "pH",  value: "8.8",      limit: "8.5",      action: "Chemical dosing adjusted" },
    ],
  },

  alerts: [
    { id: "AL-001", severity: "Critical", category: "Process",     tank: "Aeration Tank",       parameter: "DO Level",     value: "1.8 mg/L", message: "DO below minimum threshold (2.0 mg/L) for 3 consecutive hours",     time: "08:14", ack: false, assignedTo: null     },
    { id: "AL-002", severity: "Critical", category: "Blower",      tank: "Aeration Tank",       parameter: "Blower 4",     value: "Offline",  message: "Blower BL-04 offline — auto-switched to BL-03",                    time: "07:52", ack: true,  assignedTo: "Raj Kumar" },
    { id: "AL-003", severity: "Warning",  category: "Pump",        tank: "Recirculation",       parameter: "Maintenance",  value: "2 days",   message: "Recirculation pump P-04 maintenance overdue by 2 days",            time: "06:30", ack: false, assignedTo: null     },
    { id: "AL-004", severity: "Warning",  category: "Inlet",       tank: "Screen Chamber",      parameter: "TSS",          value: "420 mg/L", message: "Inlet TSS elevated — screen may be partially blocked",             time: "07:15", ack: false, assignedTo: null     },
    { id: "AL-005", severity: "Warning",  category: "Energy",      tank: "Blower Room",         parameter: "Power",        value: "54.5 kW",  message: "Total blower power consumption 12% above baseline",                time: "07:00", ack: false, assignedTo: null     },
    { id: "AL-006", severity: "Info",     category: "Sludge",      tank: "Sludge Holding Tank", parameter: "Removal",      value: "4.2 m³",   message: "Sludge removal completed — 4.2 m³ transported to composting",     time: "08:00", ack: true,  assignedTo: "Raj Kumar" },
    { id: "AL-007", severity: "Info",     category: "Compliance",  tank: "Treated Water Tank",  parameter: "BOD",          value: "8 mg/L",   message: "Daily BOD report generated — within CPCB limits",                 time: "06:00", ack: true,  assignedTo: null     },
    { id: "AL-008", severity: "Critical", category: "Compliance",  tank: "Outlet",              parameter: "pH Trending",  value: "7.6",      message: "Outlet pH trending upward — approaching upper limit (8.5)",       time: "05:48", ack: false, assignedTo: null     },
  ],

  aiInsights: [
    { id: "AI-01", priority: "High",   icon: "💧", title: "DO Crisis — Immediate Action",    insight: "Dissolved oxygen has been below 2.0 mg/L for 3+ hours. Increase BL-01 & BL-02 RPM to 1550 to restore optimal nitrification rate. Estimated DO recovery: 45 minutes.", action: "Increase blower RPM" },
    { id: "AI-02", priority: "High",   icon: "⚙", title: "Pump Failure Predicted",           insight: "Recirculation pump P-04 shows 42% failure risk based on vibration trend and overdue maintenance. Schedule immediate inspection to prevent unplanned downtime.", action: "Schedule maintenance" },
    { id: "AI-03", priority: "Medium", icon: "⚡", title: "Energy Optimization",              insight: "Blower 3 (BL-03) is operating at 1380 RPM while DO is already low. Reduce BL-03 RPM during peak inlet hours and compensate with BL-01 — net energy saving: ~8%.", action: "Optimize blower schedule" },
    { id: "AI-04", priority: "Medium", icon: "📋", title: "Compliance Risk Alert",            insight: "Outlet pH trending from 7.2 to 7.6 over 6 hours. If trend continues, pH will breach 8.5 limit in ~14 hours. Pre-emptive acid dosing recommended.", action: "Pre-emptive dosing" },
    { id: "AI-05", priority: "Low",    icon: "🔬", title: "MLSS Optimization",               insight: "MLSS at 3200 mg/L — optimal range 2500–4000. No action needed, but sludge wasting recommended in 3 days to prevent over-thickening.", action: "Schedule sludge wasting" },
    { id: "AI-06", priority: "Low",    icon: "📊", title: "Efficiency Score Drop",            insight: "STP efficiency score dropped from 88 to 82 this week due to DO instability. Restoring DO to target will recover 4–6 efficiency points.", action: "View efficiency trend" },
  ],

  reports: [
    { id: "R01", name: "Daily Compliance Report",    desc: "Outlet parameters vs. CPCB/MPCB limits",    formats: ["PDF","CSV"],   generated: "Today 06:00" },
    { id: "R02", name: "Weekly Performance Report",  desc: "7-day inlet/outlet trend and efficiency",   formats: ["PDF","Excel"], generated: "Mon 00:00"   },
    { id: "R03", name: "Pump & Motor Report",         desc: "Run hours, current, maintenance schedule",  formats: ["PDF","CSV"],   generated: "Today 06:00" },
    { id: "R04", name: "Blower Energy Report",        desc: "Power consumption, efficiency, runtime",    formats: ["PDF","CSV"],   generated: "Today 06:00" },
    { id: "R05", name: "Sludge Management Log",       desc: "Removal log, volumes, destinations",        formats: ["Excel","CSV"], generated: "Today 06:00" },
    { id: "R06", name: "Violation History Report",    desc: "All compliance violations with actions",    formats: ["PDF"],         generated: "Mon 00:00"   },
    { id: "R07", name: "Aeration Performance Report", desc: "DO trends, MLSS, blower efficiency",       formats: ["PDF","CSV"],   generated: "Today 06:00" },
    { id: "R08", name: "Monthly Audit Report",        desc: "Full MPCB audit-ready report package",      formats: ["PDF"],         generated: "1 Feb 00:00" },
  ],
};
